import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from 'src/app/icon/icon.module';
import { LicenseStatus } from 'src/app/shared/interfaces/ILicense';

interface IStatusStyle {
  label: string;
  icon: string;
  classes: string;
}

const STATUS_STYLES: Record<LicenseStatus, IStatusStyle> = {
  active: {
    label: 'active', icon: 'circle-check',
    classes: 'bg-emerald-50 border-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:border-emerald-800 dark:text-emerald-300'
  },
  expiringSoon: {
    label: 'expiring soon', icon: 'clock',
    classes: 'bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-950/40 dark:border-amber-800 dark:text-amber-300'
  },
  renewed: {
    label: 'renewed', icon: 'refresh',
    classes: 'bg-slate-50 border-slate-200 text-slate-700 dark:bg-slate-800/60 dark:border-slate-600 dark:text-slate-300'
  },
  upcoming: {
    label: 'upcoming', icon: 'calendar-event',
    classes: 'bg-blue-50 border-blue-100 text-blue-700 dark:bg-blue-950/40 dark:border-blue-800 dark:text-blue-300'
  },
  expired: {
    label: 'expired', icon: 'circle-x',
    classes: 'bg-red-50 border-red-100 text-red-700 dark:bg-red-950/40 dark:border-red-800 dark:text-red-300'
  },
  cancelled: {
    label: 'cancelled', icon: 'calendar-off',
    classes: 'bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-950/40 dark:border-amber-800 dark:text-amber-300'
  },
  notLicensed: {
    label: 'not licensed', icon: 'circle-minus',
    classes: 'bg-gray-100 border-gray-200 text-gray-600 dark:bg-gray-800/60 dark:border-gray-600 dark:text-gray-300'
  }
};

@Component({
  selector: 'app-license-status',
  imports: [TranslateModule, IconModule],
  templateUrl: './license-status.component.html'
})
export class LicenseStatusComponent {
  @Input() status: LicenseStatus | null | undefined;
  @Input() showCancelled = false;

  readonly cancelledStyle = STATUS_STYLES.cancelled;

  get style(): IStatusStyle | null {
    return this.status ? STATUS_STYLES[this.status] ?? null : null;
  }
}
